/**
 * Fundraising form: shared pure validation.
 *
 * `validateDraft` mirrors `CreateFundraisingRequestSchema` (amount ≥ 0.01,
 * currency 1–10 chars, close_month 1–12, close_year 2020–2100), keeping the
 * amount readable with the field's separators and shorthands (`parseAmount`). Pure (no React/Redux/fetch) so it is
 * unit-tested directly and reused by both form sagas.
 */
import { parseAmount } from './amount-input';
import type { FundraisingDraft, ValidationErrors } from './fundraising-draft.model';

export function validateDraft(draft: FundraisingDraft): ValidationErrors {
  const errors: ValidationErrors = {};

  const amount = parseAmount(draft.amount);
  if (!Number.isFinite(amount) || amount < 0.01) {
    errors.amount = draft.amount.trim()
      ? 'Enter a number, like 2,500,000 or 2.5m.'
      : 'Enter the amount you are raising.';
  }

  const currency = draft.currency.trim();
  if (!currency || currency.length > 10) {
    errors.currency = 'Please select a currency.';
  }

  if (!Number.isInteger(draft.closeMonth) || draft.closeMonth < 1 || draft.closeMonth > 12) {
    errors.closeMonth = 'Pick the month you plan to close.';
  }

  if (!Number.isInteger(draft.closeYear) || draft.closeYear < 2020 || draft.closeYear > 2100) {
    errors.closeYear = 'Pick a closing year between 2020 and 2100.';
  }

  return errors;
}
